import { getSiteVersion, SiteVersion } from "../../utils";

export type PopupElement = HTMLElement;

export enum PopupType {
    DROPDOWN = "dropdown",
    MODAL = "modal",
    NON_MODAL = "nonmodal",
    SHEET = "sheet",
    STATIC = "static",
}

export enum PopupTrigger {
    BUTTON = "button",
    SCROLL = "scroll",
    DELAY = "delay",
}

const POPUP_TYPE_VALUES = new Set<string>(Object.values(PopupType));
const POPUP_TRIGGER_VALUES = new Set<string>(Object.values(PopupTrigger));

export function resolvePopupType(element: PopupElement): PopupType {
    const siteVersionName = SiteVersion[getSiteVersion()].toLowerCase();
    const rawType = element.getAttribute(`data-popup-${siteVersionName}-type`)
        ?? element.getAttribute("data-popup-type")
        ?? PopupType.MODAL;

    if (POPUP_TYPE_VALUES.has(rawType)) {
        return rawType as PopupType;
    }

    console.error(`Invalid popup type: ${rawType}`, element);
    return PopupType.MODAL;
}

export function resolvePopupTrigger(element: PopupElement): PopupTrigger | null {
    const rawTrigger = element.getAttribute("data-open-trigger");

    if (rawTrigger === null) {
        return null;
    }

    if (POPUP_TRIGGER_VALUES.has(rawTrigger)) {
        return rawTrigger as PopupTrigger;
    }

    console.error(`Invalid popup trigger: ${rawTrigger}`, element);
    return null;
}

export function readIntegerAttribute(element: Element, attributeName: string): number | null {
    const rawValue = element.getAttribute(attributeName);

    if (rawValue === null) {
        return null;
    }

    const value = parseInt(rawValue, 10);

    return Number.isNaN(value) ? null : value;
}

export function popupSelector(popupId: string): string {
    return `.popup[data-popup-id="${CSS.escape(popupId)}"]`;
}

export function popupButtonSelector(popupId: string): string {
    return `.popup-button[data-popup-id="${CSS.escape(popupId)}"]`;
}

export function isPopupOpen(element: PopupElement): boolean {
    return element.hasAttribute("open");
}